import React, { useState, useRef, useEffect } from "react";
import { Row, Col, InputGroup, Form } from "react-bootstrap";
import styles from "./adcu-filter-security.module.scss";

const ADCUFilterSecurity = ({ headers, setPage, setSecurityList}) => {
  const onFirstLoad = useRef(true);
  const [ filterState, setFilterState ] = useState({
    filter: '',
    filterBy: 'securityName'
  });

  const onFilterChange = e => {
    setFilterState({
      ...filterState,
      filter: e.target.value
    })
  }

  const onFilterByChange = e => {
    setFilterState({
      ...filterState,
      filterBy: e.target.value
    })
  }

  useEffect(()=>{
    if (onFirstLoad.current)
      onFirstLoad.current = false;
    else {
      setSecurityList(prev => {
        const filteredList = prev.default.filter(s =>
          s[filterState.filterBy].toLowerCase().includes(filterState.filter.toLowerCase()));
        return {
          ...prev,
          filtered: filteredList
        }
      });
      setPage(1);
    }
  }, [filterState]);

  return (
    <div className={styles['filter']}>
      <Row>
        <Col className={styles['filter-actions']} xs={12} lg={{ span: 6, offset: 6 }}>
          <InputGroup size="sm">
            <Form.Control onChange={onFilterChange} type="text" placeholder="Search" />
            <InputGroup.Append >
              <Form.Control onChange={onFilterByChange} size="sm" as="select" defaultValue="securityName">
                {headers.map((h,i) => h.filter && <option key={i} value={h.key}>{h.value}</option>)}
              </Form.Control>
            </InputGroup.Append>
          </InputGroup>
        </Col>
      </Row>
    </div>
  );
}

export default ADCUFilterSecurity;
